import React from 'react';
import LinkBtn from './LinkBtn';

const LinkBtnContainer = () => {
  return <LinkBtn intOptionId='linkBtn' />;
};

export default LinkBtnContainer;
